<template>
    <div id="page" class="vivamod-info">


        <img src="@/images/hero-splash-2.jpeg" id="about">
        <!--<img src="assets/images/business-image.jpg" id="about">-->

        <b-container>

            <!-- chi siamo -->
            <b-row>
                <b-col xl="6" offset-xl="3" xxl="4" offset-xxl="4">
                    <section>
                        <h1 class="text-center">Chi siamo</h1>
                        <p>
                            {{site.brand}} è un servizio di travel booking che ti offre la possibilità di prenotare oltre <b>500.000 strutture tra hotel, B&B, appartamenti, residence, case e ville in tutto il mondo.</b>
                            <br/><br/>
                            Quello che ti offriamo è un servizio di booking semplice e accessibile ma soprattutto <b>un servizio di assistenza che non ha eguali</b> nel panorama nazionale ed internazionale.
                        </p>
                    </section>
                </b-col>
            </b-row>

            <section>
                <Quote :text="'Il nostro staff di assistenza è facilmente contattabile tramite canali tradizionali come il telefono e l’email ma anche tramite canali innovativi come la webchat e WhatsApp.'" />
            </section>

            <section>
                <b-row class="align-items-center">
                    <b-col sm="12" md="6">
                        <img src="assets/images/vivamod-info.png" />
                    </b-col>
                    <b-col sm="12" md="6">
                        <p>
                            Ci avvaliamo di avanzate tecnologie IT e di collaborazioni con i leader globali del travel online ma manteniamo una caratterizzazione territoriale. Infatti, <b>tutto il nostro staff</b>, dallo sviluppo tecnologico all'assistenza clienti passando per lo sviluppo strategico e commerciale, si trova <b>nella nostra sede in provincia di Rimini.</b>
                            <br/><br/>
                            Forniamo soluzioni business di online travel booking che vengono utilizzate da alcune tra le più innovative aziende italiane per il loro welfare aziendale, per il loro marketing, i piani loyalty e le incentivazioni al trade.

                            <a class="link" :href="businessVivamodHost"><b><u>Scopri di più...</u></b></a>
                            
                            <br/><br/>
                            {{site.brand}} è un servizio di Salabam srl
                        </p>
                    </b-col>
                </b-row>

                <br><br>

                <div class="mt-4 mb-4 d-flex justify-content-center">
                    <router-link :to="{name: 'homepage'}">
                    <b-button size="md" variant="cta">Cerca</b-button>
                    </router-link>
                </div>

                <div class="mt-4 mb-4 d-flex justify-content-center">
                    <router-link :to="{name: 'homepage'}">
                    <BtnBack text="Torna indietro" />
                    </router-link>
                </div>
            </section>


        </b-container>


        <b-container id="perche-scegliere-vivamod">

            <section>
                <h1 class="text-center">Perchè scegliere {{site.brand}} per prenotare le tue vacanze?</h1>

                <div class="why">
                    <div class="item">
                        <div class="icon">
                            <svg width="120" height="113" viewBox="0 0 120 113" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M73.2116 100.677H46.7871V103.984H73.2116V100.677Z" fill="#FF5652"/>
                                <path d="M46.7871 108.257C48.2741 110.007 50.0063 111.533 51.93 112.788H68.0687C69.9924 111.533 71.7246 110.007 73.2116 108.257V106.971H46.7871V108.257Z" fill="#FF5652"/>
                                <path d="M60.0014 28.7878C52.6956 28.741 45.596 31.2084 39.8939 35.776C34.1917 40.3436 30.234 46.7334 28.6849 53.8732C27.1358 61.0131 28.0894 68.4685 31.3859 74.9885C34.6823 81.5085 40.1209 86.6964 46.7892 89.6816V97.6898H73.2136V89.6816C79.8819 86.6964 85.3205 81.5085 88.617 74.9885C91.9134 68.4685 92.8671 61.0131 91.3179 53.8732C89.7688 46.7334 85.8111 40.3436 80.109 35.776C74.4068 31.2084 67.3072 28.741 60.0014 28.7878Z" fill="#FF5652"/>
                                <path d="M117.061 59.792H103.445C102.665 59.792 101.918 60.1016 101.367 60.6527C100.815 61.2039 100.506 61.9514 100.506 62.7308C100.506 63.5102 100.815 64.2577 101.367 64.8088C101.918 65.3599 102.665 65.6695 103.445 65.6695H117.061C117.84 65.6695 118.588 65.3599 119.139 64.8088C119.69 64.2577 120 63.5102 120 62.7308C120 61.9514 119.69 61.2039 119.139 60.6527C118.588 60.1016 117.84 59.792 117.061 59.792Z" fill="#FF5652"/>
                                <path d="M98.7311 44.5223C99.2469 44.5235 99.7538 44.3883 100.201 44.1305L111.992 37.3223C112.668 36.9326 113.161 36.2905 113.363 35.5373C113.565 34.7841 113.46 33.9815 113.07 33.306C112.68 32.6305 112.038 32.1375 111.285 31.9354C110.532 31.7333 109.729 31.8387 109.054 32.2284L97.2617 39.0366C96.7005 39.3596 96.2617 39.859 96.0135 40.4571C95.7653 41.0551 95.7216 41.7184 95.8891 42.3439C96.0567 42.9694 96.4261 43.522 96.94 43.9159C97.454 44.3099 98.0836 44.523 98.7311 44.5223Z" fill="#FF5652"/>
                                <path d="M93.6861 10.7022C93.3671 10.4837 93.0081 10.3304 92.6297 10.251C92.2514 10.1715 91.861 10.1675 91.4811 10.2392C91.1012 10.3108 90.7391 10.4567 90.4157 10.6686C90.0923 10.8804 89.8138 11.154 89.5963 11.4736L81.931 22.7144C81.7131 23.036 81.5607 23.3974 81.4825 23.7779C81.4042 24.1584 81.4017 24.5506 81.4751 24.9321C81.5484 25.3135 81.6962 25.6768 81.9099 26.0012C82.1237 26.3256 82.3992 26.6047 82.7208 26.8226C83.0424 27.0404 83.4038 27.1929 83.7843 27.2711C84.1648 27.3493 84.557 27.3518 84.9384 27.2785C85.3199 27.2052 85.6832 27.0574 86.0076 26.8437C86.332 26.6299 86.6111 26.3544 86.829 26.0328L94.4575 14.7552C94.8871 14.1137 95.047 13.329 94.9026 12.5706C94.7583 11.8121 94.3213 11.141 93.6861 10.7022Z" fill="#FF5652"/>
                                <path d="M35.5961 27.3059C36.132 27.3094 36.6586 27.1663 37.1191 26.8921C37.5795 26.6179 37.9562 26.223 38.2084 25.7501C38.4606 25.2773 38.5786 24.7445 38.5499 24.2093C38.5211 23.6742 38.3465 23.1571 38.0451 22.7141L30.3798 11.4732C29.9397 10.8237 29.2597 10.3756 28.4892 10.2275C27.7188 10.0794 26.9211 10.2434 26.2716 10.6835C25.6221 11.1235 25.174 11.8035 25.0259 12.574C24.8777 13.3444 25.0418 14.1421 25.4818 14.7916L33.1471 26.0324C33.4198 26.429 33.7858 26.7525 34.2128 26.9746C34.6398 27.1966 35.1148 27.3104 35.5961 27.3059Z" fill="#FF5652"/>
                                <path d="M22.6035 39.0366L10.8239 32.2284C10.1484 31.8387 9.34574 31.7333 8.59253 31.9354C7.83933 32.1375 7.19724 32.6305 6.80754 33.306C6.41783 33.9815 6.31243 34.7841 6.51451 35.5373C6.71659 36.2905 7.2096 36.9326 7.88509 37.3223L19.6647 44.1427C20.3402 44.5324 21.1428 44.6378 21.896 44.4358C22.6492 44.2337 23.2913 43.7407 23.681 43.0652C24.0707 42.3897 24.1761 41.587 23.974 40.8338C23.772 40.0806 23.2789 39.4386 22.6035 39.0488V39.0366Z" fill="#FF5652"/>
                                <path d="M111.991 87.5632L100.199 80.755C99.5234 80.3653 98.7207 80.2599 97.9675 80.462C97.2143 80.6641 96.5722 81.1571 96.1825 81.8326C95.7928 82.5081 95.6874 83.3107 95.8895 84.0639C96.0916 84.8171 96.5846 85.4592 97.2601 85.8489L109.052 92.6571C109.727 93.0468 110.53 93.1522 111.283 92.9501C112.036 92.748 112.679 92.255 113.068 91.5795C113.458 90.904 113.563 90.1014 113.361 89.3482C113.159 88.595 112.666 87.9529 111.991 87.5632Z" fill="#FF5652"/>
                                <path d="M19.6647 80.755L7.88508 87.5632C7.55061 87.7562 7.25743 88.0131 7.02226 88.3194C6.7871 88.6257 6.61456 88.9753 6.5145 89.3482C6.41444 89.7212 6.38882 90.1102 6.4391 90.493C6.48937 90.8759 6.61457 91.2451 6.80753 91.5795C7.00049 91.914 7.25745 92.2072 7.56372 92.4424C7.86999 92.6775 8.21958 92.8501 8.59253 92.9501C8.96548 93.0502 9.35448 93.0758 9.73734 93.0255C10.1202 92.9752 10.4894 92.8501 10.8239 92.6571L22.6157 85.8489C23.2912 85.4592 23.7842 84.8171 23.9863 84.0639C24.1884 83.3107 24.083 82.5081 23.6932 81.8326C23.5003 81.4981 23.2433 81.2049 22.9371 80.9698C22.6308 80.7346 22.2812 80.5621 21.9082 80.462C21.155 80.2599 20.3524 80.3653 19.6769 80.755H19.6647Z" fill="#FF5652"/>
                                <path d="M19.4939 62.7308C19.4939 61.9514 19.1843 61.2039 18.6331 60.6527C18.082 60.1016 17.3345 59.792 16.5551 59.792H2.93878C2.15936 59.792 1.41187 60.1016 0.860747 60.6527C0.30962 61.2039 0 61.9514 0 62.7308C0 63.5102 0.30962 64.2577 0.860747 64.8088C1.41187 65.3599 2.15936 65.6695 2.93878 65.6695H16.5551C16.941 65.6695 17.3232 65.5935 17.6797 65.4458C18.0363 65.2982 18.3602 65.0817 18.6331 64.8088C18.906 64.5359 19.1225 64.2119 19.2702 63.8554C19.4179 63.4988 19.4939 63.1167 19.4939 62.7308Z" fill="#FF5652"/>
                                <path d="M59.8899 19.4816C60.6694 19.4816 61.4168 19.172 61.968 18.6209C62.5191 18.0698 62.8287 17.3223 62.8287 16.5429V2.93877C62.8287 2.15936 62.5191 1.41187 61.968 0.860747C61.4168 0.30962 60.6694 0 59.8899 0C59.1105 0 58.363 0.30962 57.8119 0.860747C57.2608 1.41187 56.9512 2.15936 56.9512 2.93877V16.5429C56.9512 17.3223 57.2608 18.0698 57.8119 18.6209C58.363 19.172 59.1105 19.4816 59.8899 19.4816Z" fill="#FF5652"/>
                            </svg>                            
                        </div>
                        <div class="text">
                            <p><b>E’ easy!</b> {{site.brand}} è un servizio di booking semplice e immediato. Inoltre su {{site.brand}} troverai tante idee e suggerimenti per aiutarti a progettare un viaggio o una vacanza in linea con i tuoi sogni e il tuo stile di vita.</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M76.8101 13.1813C70.5178 6.88761 62.5007 2.60151 53.7726 0.864929C45.0446 -0.871648 35.9978 0.0192203 27.7761 3.42508C19.5544 6.83093 12.5271 12.5988 7.58304 19.999C2.63894 27.3993 0 36.0997 0 45C0 53.9003 2.63894 62.6007 7.58304 70.001C12.5271 77.4012 19.5544 83.1691 27.7761 86.5749C35.9978 89.9808 45.0446 90.8716 53.7726 89.1351C62.5007 87.3985 70.5178 83.1124 76.8101 76.8187C85.2474 68.3797 89.9875 56.9342 89.9875 45C89.9875 33.0658 85.2474 21.6203 76.8101 13.1813ZM67.0428 36.8148L64.0364 39.8231L50.8945 52.9655C48.1404 55.7098 45.3935 58.4574 42.6541 61.2086C41.7839 62.0532 40.619 62.5257 39.4065 62.5257C38.1939 62.5257 37.0292 62.0532 36.1591 61.2086C35.6188 60.6682 35.0801 60.1297 34.5518 59.5893C30.7534 55.778 26.9547 51.9708 23.1552 48.1686C22.7199 47.744 22.373 47.2375 22.135 46.6779C21.897 46.1183 21.7725 45.5166 21.7686 44.9084C21.7648 44.3003 21.8816 43.6978 22.1125 43.1352C22.3434 42.5726 22.6839 42.0613 23.1138 41.6313C23.5438 41.2012 24.0549 40.861 24.6174 40.63C25.1799 40.3991 25.7827 40.282 26.3908 40.2859C26.9988 40.2897 27.6 40.4144 28.1596 40.6525C28.7191 40.8906 29.2257 41.2374 29.6502 41.6729C30.1905 42.2115 30.729 42.7518 31.2574 43.2905C33.9774 46.0109 36.6935 48.7352 39.4057 51.4636L52.3074 38.5618L60.5476 30.3204C61.4126 29.4769 62.5751 29.0081 63.7832 29.0157C64.9912 29.0234 66.1476 29.5068 67.0018 30.3611C67.8561 31.2155 68.3394 32.3722 68.3471 33.5805C68.3547 34.7887 67.8862 35.9513 67.0428 36.8164V36.8148Z" fill="#FF5652"/>
                            </svg>
                        </div>
                        <div class="text">
                            <p><b>E’ sicuro.</b> La sicurezza del tuo viaggio è la nostra priorità e per questo i nostri algoritmi selezionano le strutture che ti proponiamo in base alla loro qualità e alla professionalità della loro gestione. Inoltre, prima del tuo arrivo, facciamo un controllo con la struttura per verificare che sia tutto pronto per riceverti.</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <svg width="99" height="90" viewBox="0 0 99 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M98.316 34.3909C99.2494 28.9105 98.6344 23.2785 96.5399 18.1288C94.4455 12.979 90.9551 8.51616 86.4615 5.24292C81.5743 1.75065 75.6975 -0.0854976 69.6914 0.0030592C65.8971 0.0285362 62.1462 0.812529 58.6594 2.30889C55.1726 3.80526 52.0203 5.98377 49.3878 8.71633C45.3758 4.62453 40.2279 1.83141 34.6105 0.698564C28.993 -0.434286 23.1649 0.144962 17.8806 2.36201C14.3531 3.8101 11.164 5.97394 8.51464 8.71633C5.76467 11.4862 3.60323 14.7836 2.16055 18.4104C0.725038 21.8777 -0.00922495 25.5952 8.7481e-05 29.348C-0.00476642 33.1215 0.729163 36.8595 2.16055 40.351C3.59452 43.963 5.75761 47.2407 8.51464 49.9796L47.2891 89.1481C47.5619 89.4257 47.8889 89.6445 48.2495 89.7909C48.6101 89.9374 48.9968 90.0081 49.386 89.9993C49.7645 90.0038 50.1399 89.931 50.489 89.7845C50.838 89.6381 51.1533 89.4214 51.4152 89.1481L90.2573 49.8482C94.5209 45.6845 97.346 40.2699 98.3217 34.3909" fill="#FF5652"/>
                            </svg>                          
                        </div>
                        <div class="text">
                            <p><b>Siamo gentili e disponibili.</b> Nella webchat di assistenza, nel canale WhatsApp o via email troverai la cultura del turismo Romagnola fatta di disponibilità, simpatia e attenzione.</p>
                        </div>
                    </div>
                </div>

                <div class="mt-4 mb-4 d-flex justify-content-center">
                    <router-link :to="{name: 'homepage'}">
                    <b-button size="md" variant="cta">Cerca</b-button>
                    </router-link>
                </div>

                <div class="mt-4 mb-4 d-flex justify-content-center">
                    <router-link :to="{name: 'homepage'}">
                    <BtnBack text="Torna indietro" />
                    </router-link>
                </div>
            </section>

        </b-container>

        <!--
        <b-container fluid>
          <section>
            <Prefooter />
          </section>
        </b-container>
        -->


        <!-- contatti -->
        <b-container id="assistenza">

          <section class="text-left">

                <b-row>
                    <b-col sm="12" xl="10" offset-xl="2">
                        <h2>Assistenza e contatti</h2>
                        <br>
                        <p>
                            Puoi contattarci per qualsiasi informazione e richiesta di supporto utilizzando uno dei canali indicati qui sotto.
                            <br><br>
                            Troverai sempre un’assistenza attenta, tempestiva, gentile e professionale.
                        </p>
                    </b-col>
                </b-row>

                <br><br>
                
                <!--<b-row>
                    <b-col sm="12" xl="10" offset-xl="2">
                        <Quote :text="'Se invece sei interessato ad una soluzione aziendale scrivici all’indirizzo <a href=mailto:'+site.emailBusiness+'>'+site.emailBusiness+'</a>'" />
                    </b-col>
                </b-row>

                <br><br><br>-->

                <b-row class="info">
                    <b-col sm="12" xl="10" offset-xl="2">
                        <p>
                            <strong>{{site.brand}} è un servizio di Salabam srl</strong>
                        </p>

                        <p>
                            <svg width="29" height="35" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14 35C21.3387 31.6129 28.2258 21.9072 28.2258 14.1129C28.2258 6.31856 21.9072 0 14.1129 0C6.31856 0 0 6.31856 0 14.1129C0 21.9072 7.3871 31.5 14 35ZM13.8309 20.3226C17.728 20.3226 20.8873 17.1634 20.8873 13.2662C20.8873 9.36902 17.728 6.20974 13.8309 6.20974C9.93369 6.20974 6.77441 9.36902 6.77441 13.2662C6.77441 17.1634 9.93369 20.3226 13.8309 20.3226Z" fill="#FF5652"/>
                            </svg>                            
                            <strong>{{site.address}}</strong>
                        </p>

                        <p>
                            <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M35 16.4637C34.4789 7.97715 27.779 0.979505 19.2925 0.0861876C14.007 -0.434914 8.87047 1.42616 5.14832 5.14832C1.42616 8.87047 -0.434914 14.007 0.0861876 19.2925C0.905062 27.5557 7.5305 34.1067 15.7937 34.9256C16.3892 35 16.9848 35 17.5803 35C21.0791 35 24.3546 34.0322 27.2579 32.0223C28.0023 31.5012 28.2257 30.459 27.7046 29.7145C27.1835 28.9701 26.1413 28.7468 25.3968 29.2679C22.6424 31.129 19.4414 31.8734 16.1659 31.5756C9.46602 30.9056 4.18056 25.6202 3.51057 18.9203C3.06391 14.677 4.55277 10.5082 7.60494 7.45605C10.6571 4.40389 14.7515 2.98947 19.0692 3.36168C25.9179 4.03167 31.3523 9.68935 31.7245 16.6126C31.7989 18.4736 31.5756 20.3347 30.9801 22.0469C30.5334 23.3124 29.3423 24.2058 27.9279 24.2058C26.1413 24.2058 24.7269 22.7913 24.7269 21.0047V10.5082C24.7269 9.6149 23.9824 8.79603 23.0147 8.79603C22.0469 8.79603 21.3025 9.54046 21.3025 10.5082V11.0293C19.9625 10.0616 18.3992 9.54046 16.6126 9.54046C12.2204 9.46602 8.5727 13.1137 8.5727 17.5059C8.5727 21.898 12.146 25.5457 16.6126 25.5457C18.6225 25.5457 20.4092 24.8013 21.8236 23.6102C22.8658 25.9179 25.1735 27.6301 27.8535 27.6301C30.6823 27.6301 33.1389 25.8435 34.1067 23.238C34.7767 21.0047 35.0744 18.7714 35 16.4637ZM16.6126 22.1958C14.007 22.1958 11.9226 20.1114 11.9226 17.5059C11.9226 14.9004 14.007 12.816 16.6126 12.816C19.2181 12.816 21.3025 14.9004 21.3025 17.5059C21.3025 20.1114 19.1436 22.1958 16.6126 22.1958Z" fill="#FF5652"/>
                            </svg>                            
                            <strong><a href="mailto:info@salabam.com">info@salabam.com</a></strong>
                        </p>

                        <p>
                            <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.72906 2.21383C9.39739 1.10826 9.06572 0.223795 7.96014 0.113237L5.85955 0.0026799C3.6484 -0.107878 0 3.20885 0 8.73673C0.110558 18.3552 14.483 34.0544 23.991 34.9389C29.6294 35.4917 33.1673 32.1749 33.2778 29.8532V27.8632C33.3884 26.7576 32.5039 26.3154 31.3983 25.8731C29.2978 25.0992 27.1972 24.1042 25.0966 23.3303C24.2121 22.9987 23.4382 23.5514 22.8854 23.8831C22.1115 24.5465 21.5587 24.9887 20.8954 25.7626C20.3426 26.2048 19.7898 26.4259 19.237 25.8731C14.483 23.4409 10.6135 19.2397 8.62349 14.3752C8.18126 13.7118 8.40237 13.159 8.95516 12.7168C9.72906 12.0535 10.2819 11.5007 10.9452 10.8373C11.3874 10.3951 11.9402 9.62119 11.7191 8.73673C11.0558 6.63613 10.3924 4.31442 9.72906 2.21383Z" fill="#FF5652"/>
                            </svg>                            
                            <strong><a :href="'phone:'+site.phoneNumber">{{site.phoneNumber}}</a></strong>
                        </p>

                        <p>
                            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.4679 36.4815C21.0766 36.4815 22.5984 36.4815 23.8158 35.2641C24.6273 34.4525 25.0331 33.2351 25.0331 31.7134C25.0331 30.8004 24.8302 30.0902 24.6273 29.3801C25.236 28.6699 25.7433 27.554 25.7433 25.6264C25.7433 24.8148 25.6418 24.2061 25.5404 23.6989C26.2505 22.9888 26.7578 21.7714 26.7578 19.8438C26.7578 19.5395 26.7578 19.2351 26.7578 19.0322H31.7288C31.9317 19.0322 32.0331 19.0322 32.236 18.9308C33.4534 18.6264 35.4824 17.2061 35.4824 13.9598C35.4824 10.9163 33.1491 9.39456 31.9317 9.09021C31.7288 9.09021 31.6273 8.98876 31.4245 8.98876L20.265 8.98876C20.7723 8.38006 21.2795 7.66992 21.4824 6.65543C21.6853 5.33658 21.2795 4.01774 20.265 2.6989C19.0476 1.17716 16.41 -0.953271 12.5549 1.98876C10.323 3.7134 1.49691 10.9163 1.19257 11.2206C0.685322 11.6264 0.482422 12.2351 0.482422 12.7424C0.482422 13.1482 0.58387 13.6554 0.98967 14.0612C1.69981 14.9743 3.01865 15.0757 3.83025 14.3656C3.9317 14.2641 12.9607 6.85832 15.0911 5.23513C16.2071 4.42354 16.41 4.32209 17.1201 5.33658C17.5259 5.74238 17.5259 6.04673 17.5259 6.14818C17.4244 6.45253 16.6129 6.95977 16.41 7.06122L16.1056 7.26412C14.4824 8.38006 13.265 9.6989 13.1636 9.80035C12.6563 10.409 12.4534 11.2206 12.8592 12.0322C13.1636 12.7424 13.8737 13.2496 14.6853 13.2496L30.9172 13.2496C31.1201 13.3511 31.323 13.554 31.323 14.0612C31.323 14.5685 31.2216 14.8728 31.1201 15.0757H23.2071H21.7868L16.41 15.0757C15.294 15.0757 14.381 15.9888 14.381 17.1047C14.381 18.2206 15.294 19.1337 16.41 19.1337H21.7868H22.5984C22.5984 19.3366 22.6998 19.5395 22.6998 19.9453C22.6998 20.3511 22.6998 20.6554 22.5984 20.7569H16.7143C15.5984 20.7569 14.6853 21.6699 14.6853 22.7859C14.6853 23.9018 15.5984 24.8148 16.7143 24.8148H21.5839C21.5839 25.0177 21.6853 25.2206 21.6853 25.6264C21.6853 26.0322 21.6853 26.3366 21.5839 26.438H20.5694H19.6563H16.0042C14.8882 26.438 13.9752 27.3511 13.9752 28.467C13.9752 29.583 14.8882 30.496 16.0042 30.496H19.6563H20.5694C20.5694 30.496 20.9752 30.496 20.9752 31.6119C20.9752 32.0177 20.8737 32.2206 20.9752 32.2206C20.8737 32.2206 20.5694 32.2206 20.4679 32.2206C19.352 32.2206 15.8013 32.2206 12.2505 32.2206H3.01865C1.90271 32.2206 0.98967 33.1337 0.98967 34.2496C0.98967 35.3656 1.90271 36.2786 3.01865 36.2786H12.2505C15.8013 36.4815 19.352 36.4815 20.4679 36.4815Z" fill="#FF5652"/>
                            </svg>
                            <strong>p.IVA: 04238550406</strong>
                        </p>
                    </b-col>
                </b-row>

                <div class="mt-4 mb-4 d-flex justify-content-center">
                    <router-link :to="{name: 'homepage'}">
                    <b-button size="md" variant="cta">Cerca</b-button>
                    </router-link>
                </div>                
            
          </section>

        </b-container>

    </div>
</template>

<script>
  import Quote from '@/components/blocks/common/quote'
  import BtnBack from '@/components/atoms/btn-back'

  export default {
    name: 'page',
    metaInfo: {
      title: 'informazioni',
    },
    components: {
        Quote,
        BtnBack
    },
    data() {
        return {
          site: this.appConfig().site,
          checklistItems_mission : {
            0: "Il continuo sforzo di sviluppo tecnologico degli algoritmi che\n" +
              "selezionano i migliori tra gli oltre 500.000 hotel disponibili a cui\n" +
              "accediamo a livello italiano e internazionale, come anche lo sviluppo\n" +
              "di innovativi meccanismi di double check delle prenotazioni, non\n" +
              "sarebbero nulla senza la gentilezza, la competenza e la disponibilità\n" +
              "del nostro staff di customer care",
            1: "L'incessante lavoro di miglioramento\n" +
              "della user experience del nostro sito web non sarebbe nulla senza la\n" +
              "profonda comprensione, da parte del nostro management, dell'universo\n" +
              "travel nelle sue incessanti evoluzioni e cambiamenti",
          },
          numberedItems_comeFunziona : {
            0: {
                title: "DEVI ACCEDERE PASSANDO DAL PORTALE WELFARE",
                content: "<b>per utilizzare il servizio occorre accedere a " + this.appConfig().site.brand + " partendo dal link dentro al proprio portale welfare.</b><br>Se sei arrivato su questo sito da Google o digitando l’indirizzo " + this.appConfig().site.host + " sul browser stai visualizzando una versione che non permette di fare ricerche e prenotazioni."
              },
            1: {
                title: "COME PAGARE LA PRENOTAZIONE",
                content: "il <b>pagamento della prenotazione</b> è la cosa più semplice del mondo perchè viene fatto tramite <b>addebito diretto e automatico sul tuo credito welfare.</b> Non è possibile pagare con carta di credito."
              },
              /*
            2: {
                title: "COME PAGARE LA PRENOTAZIONE",
                content: "una volta che sei acceduto a " + this.appConfig().site.brand + " partendo dal tuo portale welfare il <b>pagamento della prenotazione</b> è la cosa più semplice del mondo perchè viene fatto tramite <b>addebito diretto e automatico sul proprio credito welfare.</b>"
              },
              */
          },
          businessVivamodHost: process.env.VUE_APP_BUSINESS_VIVAMOD_HOST,
        }
    },
    mounted() {

    },
    methods:{

    }
  }
</script>

<style lang="scss">
    
    
    
    @import '@/scss/_vivamod.scss';

    .page-informazioni,
    .page-about,
    .page-contacts
    {
        @extend .vivamod !optional;

        .title,
        h1,h2,h3,h4,h5,h6
        {
            font-weight: 600 !important;
        }

        .quote
        {
            max-width: 800px;
            .first-color,
            .last-color
            {
                stop-color:#FF5652 !important;
            }
        }

        .why
        {
            .item
            {
                display:flex;
                margin-bottom:$grid-gutter-width;
            }
            .icon
            {
                padding-right:$grid-gutter-width/2;
                min-width:100px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                svg
                {
                    margin:auto;
                }
            }
            .text
            {
                display: flex;
                align-items: center;
                p
                {
                    margin-bottom:0;
                }
            }
            .item:nth-child(1) svg
            {
                $w:65px;
                width:$w;
                min-width:$w;
                max-width:$w;
                height: auto;
            }
            .item:nth-child(2) svg,
            .item:nth-child(3) svg
            {
                $w:50px;
                width:$w;
                min-width:$w;
                max-width:$w;
                height: auto;
            }
        }

        .info
        {
            strong,b
            {
                font-weight: 500;
            }
            a,a:hover
            {
                color:$black;
                text-decoration: none;
            }
            svg
            {
                width:20px;
                height:auto;
                margin-right:16px;
            }
            @include media-breakpoint-up(md)
            {
                p
                {
                    display:inline-block;
                    vertical-align: middle;
                    width:33%;
                    margin-bottom:1rem;
                }
                p:nth-child(1)
                {
                    margin-bottom:2rem;
                }
                p:nth-child(1),
                p:nth-child(2)
                {
                    display: block;
                    width:100%;
                }
            }
        }
    }
    
    .vivamod-info
    {
        .btn
        {
            border-radius: $border-radius-sm;
            padding:0.5rem 1.5rem;
        }
    }
</style>